
export const showAdapterErrors = false;
